import {connect} from 'react-redux';

export const IS_BROWSER = typeof window !== 'undefined';

/**
 * A React higher-order component that determines the render strategy to use
 *
 * The following props are passed to the wrapped component:
 *
 * - ssr (boolean): Whether the component should be rendered on the server side (true)
 *   or only on the client side (false)
 */
export const withRenderStrategy = connect(({config, abacus}, ownProps) => ({
    ssr: config.context.isBot,
    abacus,
    ...ownProps,
}));
